import { lazy, Suspense, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSettings } from '@/contexts/SettingsContext';
import { cn } from '@/lib/utils';

export const WHATSAPP_PLACEHOLDER = '{{whatsapp}}';

const RichTextEditor = lazy(() => import('./RichTextEditor'));

const escapeHtml = (s) =>
  String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

/** {{whatsapp}} → رابط واتساب برقم الموقع، والروابط الخارجية تفتح في تاب جديد */
const renderHtml = (html, site) => {
  const whatsapp = site.whatsapp_url
    ? `<a href="${escapeHtml(site.whatsapp_url)}" dir="ltr">${escapeHtml(site.whatsapp_display)}</a>`
    : `<span dir="ltr">${escapeHtml(site.whatsapp_display)}</span>`;

  const template = document.createElement('template');
  template.innerHTML = String(html ?? '').split(WHATSAPP_PLACEHOLDER).join(whatsapp);
  template.content.querySelectorAll('a[href]').forEach((a) => {
    if (/^https?:\/\//i.test(a.getAttribute('href'))) {
      a.target = '_blank';
      a.rel = 'noopener noreferrer';
    }
  });
  return template.innerHTML;
};

/** عرض HTML المحفوظ (متنضّف في السيرفر) */
export const RichHtml = ({ html, className }) => {
  const site = useSettings();
  const navigate = useNavigate();
  const rendered = useMemo(() => renderHtml(html, site), [html, site]);

  if (!html) return null;

  return (
    <div
      className={cn('page-rich', className)}
      // الروابط الداخلية (/privacy) من غير ما الصفحة تعمل reload
      onClick={(e) => {
        const href = e.target.closest('a')?.getAttribute('href');
        if (href?.startsWith('/') && !href.startsWith('//')) {
          e.preventDefault();
          navigate(href);
        }
      }}
      dangerouslySetInnerHTML={{ __html: rendered }}
    />
  );
};

/** نص منسّق: عرض عادي، أو محرّر في وضع التعديل */
const RichText = ({ html, onChange, editing, className, placeholder }) =>
  editing ? (
    <Suspense fallback={<RichHtml html={html} className={className} />}>
      <RichTextEditor html={html} onChange={onChange} className={className} placeholder={placeholder} />
    </Suspense>
  ) : (
    <RichHtml html={html} className={className} />
  );

export default RichText;
